import styled from "@emotion/styled";

export const TableSkeletonWithTabsContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: 8,
	padding: 16
});
